import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {FrontOperatorSupportContact, SupportContact} from '../../domain/operator/frontEndConfig';
import {FrontEndHttpService} from '../http/frontEndHttp.service';
import {SupportContactRestrictionArea} from '../../domain/enum/supportContactRestrictionArea';
import {isEmpty} from 'lodash-es';


@Injectable({
    providedIn: 'root'
})
export class SupportContactBusinessService {
    // Store last requested third party id to handle twinning relationships and be able to reassign supportContacts$ (and defeat shareReplay)
    private currentThirdPartyId: string;

    private supportContacts$: Observable<SupportContact[]>;

    constructor(private readonly frontEndService: FrontEndHttpService) {
    }

    public findSupportContacts(thirdPartyId: string, restrictionArea?: SupportContactRestrictionArea): Observable<SupportContact[]> {
        if (!this.currentThirdPartyId || this.currentThirdPartyId !== thirdPartyId) {
            this.currentThirdPartyId = thirdPartyId;

            this.supportContacts$ = this.frontEndService.findSupportConfig(thirdPartyId)
                .pipe(
                    map(supportConfig => supportConfig?.supportContacts),
                    shareReplay(1)
                );
        }

        return this.supportContacts$.pipe(
            map((supportContacts: SupportContact[]) =>
                supportContacts.filter(supportContact =>
                    restrictionArea == null
                    || this.supportContactHasNoRestriction(supportContact)
                    || this.supportContactVisibleInArea(restrictionArea, supportContact)
                )
            )
        );
    }

    private supportContactHasNoRestriction = (supportContact: SupportContact) => {
        switch (supportContact['@type']) {
            case 'technicalSupportContact':
                return false;
            case 'frontOperatorSupportContact':
                return isEmpty((supportContact as FrontOperatorSupportContact).restrictionAreas);
            default:
                return false;
        }
    };

    private supportContactVisibleInArea =
        (restrictionArea: SupportContactRestrictionArea, supportContact: SupportContact) => {
            switch (supportContact['@type']) {
                case 'technicalSupportContact':
                    return false;
                case 'frontOperatorSupportContact':
                    return (supportContact as FrontOperatorSupportContact).restrictionAreas.includes(restrictionArea);
                default:
                    return false;
            }
        };
}
